export default __webpack_public_path__ + "static/media/portfolio_4.e217b5c0.png";